import {PropertyBase} from "./PropertyBase";

export class SeparatorProperty extends PropertyBase{
    constructor(label:string=''){
        super(null,null);
        this.SetLabel(label);
    }

    protected InternalGetElement(): JQuery {
        return jQuery('<hr/>');
    }

    protected InternalGenerationCompleted($element: JQuery) {
    }

    public SubRenderer(): React.ReactNode {
        return undefined;
    }


}
